import React from 'react';
import styled from 'styled-components';
import { defaultMuiTheme } from '../../../../styles/MaterialTheme';
export const CATALOG_IMAGE_SIZE = '125px';
export const SMALL_CATALOG_IMAGE_SIZE = '56px';
const CatalogImageContainer = styled.div `
    width: ${CATALOG_IMAGE_SIZE};
    height: ${CATALOG_IMAGE_SIZE};

    background-color: ${(props) => (props.$isDefault ? props.theme.colors.surface : 'transparent')};
    border-radius: 50%;
    margin-bottom: 2rem;

    ${defaultMuiTheme.breakpoints.down('xs')} {
        width: ${SMALL_CATALOG_IMAGE_SIZE};
        height: ${SMALL_CATALOG_IMAGE_SIZE};
    }
`;
const CatalogImage = styled.img `
    height: 100%;
    width: 100%;
    background-size: cover;
    border-radius: 50%;
    object-fit: cover;
`;
const CollectionCatalogImage = ({ isDefault, src }) => {
    return (React.createElement(CatalogImageContainer, { "$isDefault": isDefault },
        React.createElement(CatalogImage, { src: src })));
};
export default CollectionCatalogImage;
//# sourceMappingURL=index.js.map